export const CDA_4_KIND = 119;
